import { render, staticRenderFns } from "./_mobileContainer.vue?vue&type=template&id=28fc473e&"
import script from "./_mobileContainer.vue?vue&type=script&lang=ts&"
export * from "./_mobileContainer.vue?vue&type=script&lang=ts&"
import style0 from "./_mobileContainer.vue?vue&type=style&index=0&id=28fc473e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports